<template>
  <academy-form
    action="create"
    :loading="loading"
    :updating="creating"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { computed, ref, getCurrentInstance } from '@vue/composition-api'

import AcademyForm from './academy-form/AcademyForm.vue'

export default {
  components: {
    AcademyForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy

    const academyForm = ref(null)
    const errorMessages = ref([])

    const loading = ref(false)
    const creating = computed(() => vm.$store.getters['academies/creating'])

    const handleFormSubmit = formData => {
      vm.$store
        .dispatch('academies/create', formData)
        .then(res => {
          if (res?.status === 200 && res?.data?.data?.academy) {
            const academyId = res.data.data.academy.id

            vm.$router.replace({
              name: 'academy-view',
              params: {
                id: academyId,
              },
            })
          }
        })
        .catch(err => {
          if (err?.data?.errors) {
            errorMessages.value = err.data.errors
          }
        })
    }

    const handleDiscard = () => vm.$router.replace({ name: 'academy-list' })

    return {
      loading,
      creating,

      academyForm,

      errorMessages,

      handleFormSubmit,
      handleDiscard,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
